<template>
  <div class="filas-checkbox">
    <label v-if="title">{{ title }}</label>
    <div class="input-group input-group-sm mb-1">
      <div class="input-group-prepend">
        <span class="input-group-text"><i class="fas fa-search fa-fw"></i></span>
      </div>
      <input type="text" class="form-control" placeholder="Buscar fila" v-model="busca" @keydown.enter.prevent />
    </div>
    <div class="filas-checkbox-lista" :style="{ maxHeight: altura }">
      <!-- v-show (E NÃO FILTRO NO v-for) PARA A BUSCA NÃO TIRAR DO FORM FILAS JÁ MARCADAS -->
      <div class="custom-control custom-checkbox" v-for="fila in todas" :key="fila.id" v-show="filasFiltradas.includes(fila)">
        <input
          type="checkbox"
          class="custom-control-input"
          :id="`${id}_fila_${fila.id}`"
          :name="name"
          :value="String(fila.id)"
          v-model="selecionadas"
          @change="emitir"
        />
        <label class="custom-control-label" :for="`${id}_fila_${fila.id}`">
          {{ fila.alias ? fila.alias : fila.name }}
          <small v-if="contagens" class="text-muted">— {{ contagens[String(fila.id)] || 0 }} de {{ total }}</small>
        </label>
      </div>
      <small v-if="filasFiltradas.length == 0" class="text-muted">Nenhuma fila encontrada.</small>
    </div>
    <div class="mt-1">
      <small class="text-muted">{{ selecionadas.length }} selecionada(s)</small>
      <a href="javascript:void(0)" class="ml-2" @click="limpar" v-if="selecionadas.length > 0"><small>Limpar</small></a>
    </div>
  </div>
</template>

<script>
// LISTA DE FILAS COM CHECKBOX E BUSCA (SUBSTITUI O <select multiple>, ONDE UM CLIQUE SEM CTRL APAGAVA A SELEÇÃO)
// USO COM v-model (MODAL DE LOTE) OU DENTRO DE <form> VIA "name" (TELA EDITAR USUÁRIO).
// FORA DO VUE (jQuery) OS VALORES SÃO DEFINIDOS COM O EVENTO:
// window.dispatchEvent(new CustomEvent('filas-checkbox:definir', { detail: { id: 'queue', valores: ['1', '3'] } }))
export default {
  props: {
    id: { type: String, default: 'filas' },
    name: { type: String, default: null },
    title: { type: String, default: null },
    value: { type: Array, default: () => [] },
    filas: { type: Array, default: null },
    contagens: { type: Object, default: null },
    total: { type: Number, default: 0 },
    altura: { type: String, default: '184px' },
  },
  data() {
    return {
      busca: '',
      lista: [],
      selecionadas: this.value.map(String),
    };
  },
  computed: {
    todas() {
      return this.filas || this.lista;
    },
    filasFiltradas() {
      const termo = this.busca.trim().toLowerCase();
      if (!termo) return this.todas;
      return this.todas.filter(f => `${f.alias || ''} ${f.name}`.toLowerCase().includes(termo));
    },
  },
  watch: {
    value(novo) {
      this.selecionadas = (novo || []).map(String);
    },
  },
  mounted() {
    if (!this.filas) {
      axios.get('/user/listQueue')
        .then(response => { this.lista = response.data || []; })
        .catch(error => { console.error(error); });
    }
    window.addEventListener('filas-checkbox:definir', this.definir);
  },
  beforeDestroy() {
    window.removeEventListener('filas-checkbox:definir', this.definir);
  },
  methods: {
    definir(event) {
      if (!event.detail || event.detail.id !== this.id) return;
      this.selecionadas = (event.detail.valores || []).map(String);
      this.busca = '';
      this.emitir();
    },
    limpar() {
      this.selecionadas = [];
      this.emitir();
    },
    emitir() {
      this.$emit('input', this.selecionadas.slice());
    },
  },
};
</script>

<style scoped>
.filas-checkbox-lista {
  overflow-y: auto;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding: 6px 10px;
  background: #fff;
}
</style>
